import React, {
    useEffect,
    useRef
}
from "react";

import * as am4core
from "@amcharts/amcharts4/core";

import * as am4charts
from "@amcharts/amcharts4/charts";

import am4themes_animated
from "@amcharts/amcharts4/themes/animated";

import { LICENCE_KEY }
from "../../../../constants/charts";


am4core.useTheme(
    am4themes_animated
);

am4core.addLicense(
    LICENCE_KEY
);


export default function InsightDashboardUrgencyChart({
    data = [],
    clickFunction
})
{

    const chartRef =
        useRef(null);


    //--------------------------------------------------------
    // Get urgency colour
    //--------------------------------------------------------

    function getColour(name)
    {
        const value =
            (name || "")
                .trim()
                .toUpperCase();


        switch(value)
        {
            case "CRITICAL":
            case "IMMEDIATE":
                return "#e84d4f";

            case "HIGH":
            case "URGENT":
                return "#f47b2c";

            case "MEDIUM":
                return "#f4b73f";

            case "LOW":
                return "#38b878";

            default:
                return "#6eaeff";
        }
    }


    //--------------------------------------------------------
    // Map data
    //--------------------------------------------------------

    function mapData(rows)
    {
        return (
            rows
            ||
            []
        ).map(
            (item) =>
            {
                return {
                    name:
                        item.name,

                    value:
                        item.total,

                    colour:
                        getColour(
                            item.name
                        ),

                    originalData:
                        item
                };
            }
        );
    }


    //--------------------------------------------------------
    // Create chart
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                !data
                ||
                data.length === 0
            )
            {
                return;
            }


            const chart =
                am4core.create(
                    "insight-dashboard-urgency-chart",
                    am4charts.RadarChart
                );


            chart.padding(
                5,
                10,
                5,
                10
            );


            chart.data =
                mapData(
                    data
                );


            //------------------------------------------------
            // Category axis
            //------------------------------------------------

            const categoryAxis =
                chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );


            categoryAxis.dataFields.category =
                "name";


            categoryAxis.renderer.grid.template.location =
                0;


            categoryAxis.renderer.grid.template.stroke =
                am4core.color(
                    "#d8dee7"
                );

            categoryAxis.renderer.grid.template.strokeOpacity =
                0.65;


            categoryAxis.renderer.labels.template.fill =
                am4core.color(
                    "#667180"
                );

            categoryAxis.renderer.labels.template.fontSize =
                8;

            categoryAxis.renderer.labels.template.fontWeight =
                "600";


            //------------------------------------------------
            // Value axis
            //------------------------------------------------

            const valueAxis =
                chart.yAxes.push(
                    new am4charts.ValueAxis()
                );


            valueAxis.min =
                0;


            valueAxis.renderer.grid.template.stroke =
                am4core.color(
                    "#d8dee7"
                );

            valueAxis.renderer.grid.template.strokeOpacity =
                0.45;


            valueAxis.renderer.labels.template.disabled =
                true;


            //------------------------------------------------
            // Series
            //------------------------------------------------

            const series =
                chart.series.push(
                    new am4charts.RadarSeries()
                );


            series.dataFields.valueY =
                "value";

            series.dataFields.categoryX =
                "name";


            series.strokeWidth =
                2;


            series.stroke =
                am4core.color(
                    "#477df5"
                );


            series.fill =
                am4core.color(
                    "#477df5"
                );

            series.fillOpacity =
                0.12;


            //------------------------------------------------
            // Bullets
            //------------------------------------------------

            const bullet =
                series.bullets.push(
                    new am4charts.CircleBullet()
                );


            bullet.circle.radius =
                12;


            bullet.circle.stroke =
                am4core.color(
                    "#ffffff"
                );

            bullet.circle.strokeWidth =
                2;


            bullet.circle.propertyFields.fill =
                "colour";


            bullet.circle.tooltipText =
                "{name}\n[bold]{value} insights[/]";


            //------------------------------------------------
            // Number inside bullet
            //------------------------------------------------

            const label =
                bullet.createChild(
                    am4core.Label
                );


            label.text =
                "{value}";

            label.horizontalCenter =
                "middle";

            label.verticalCenter =
                "middle";

            label.fill =
                am4core.color(
                    "#ffffff"
                );

            label.fontSize =
                7;

            label.fontWeight =
                "700";


            //------------------------------------------------
            // Hover
            //------------------------------------------------

            const hover =
                bullet.circle.states
                    .create(
                        "hover"
                    );


            hover.properties.scale =
                1.18;


            //------------------------------------------------
            // Click
            //------------------------------------------------

            bullet.events.on(
                "hit",
                function(event)
                {
                    if(!clickFunction)
                    {
                        return;
                    }


                    const item =
                        event.target
                            .dataItem
                            .dataContext;


                    if(!item)
                    {
                        return;
                    }


                    clickFunction(
                        item.originalData
                    );
                }
            );


            chartRef.current =
                chart;


            //------------------------------------------------
            // Cleanup
            //------------------------------------------------

            return () =>
            {
                chart.dispose();

                chartRef.current =
                    null;
            };
        },
        [
            data,
            clickFunction
        ]
    );


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            id="insight-dashboard-urgency-chart"

            style={{
                width: "100%",
                height: "100%"
            }}
        />

    );
}